<template>
  <div
    v-if="isVisible"
    class="alter-box-container"
  >
    <div
      :class="`alert-box type-${type}`"
    >
      <span class="text">
        <slot />
      </span>
    </div>    
  </div>
</template>

<script>
  export default {
    props: {
      type: {
        type: String,
        default: 'default'
      },
      isVisible: {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .alter-box-container {
    border-bottom: 1px solid rgba(#000, .1);
    margin-bottom: 1.5625rem;
    padding-bottom: 1.5625rem;

    .alert-box {
      padding: 20px 15px;
      border-radius: 5px;
      box-shadow: 1px 1px 6px 1px rgba(#000, .1);
      background-color: $purple600;

      .text {
        display: block;
        font-size: 0.89rem;
      }

      &.type-success { color: #28a745; border-color: #28a745 }
      &.type-danger { color: #dc3545; border-color: #dc3545 }
      &.type-info { color: #17a2b8; border-color: #17a2b8 }
    }
  }
</style>